export const CoffeeCupIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="42" fill="none" viewBox="0 0 43 42">
      <g
        stroke="#693EB5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        clipPath="url(#clip0_3652_34547)"
      >
        <path d="M7.5 18.375h21a1.75 1.75 0 011.75 1.75v5.25a10.5 10.5 0 01-10.5 10.5h-3.5a10.5 10.5 0 01-10.5-10.5v-5.25a1.75 1.75 0 011.75-1.75zM24.125 13.125a3.172 3.172 0 010-4.375 3.172 3.172 0 000-4.375M18 13.125a3.172 3.172 0 010-4.375 3.172 3.172 0 000-4.375M11.875 13.125a3.172 3.172 0 010-4.375 3.172 3.172 0 000-4.375"></path>
        <path d="M28.724 30.826l3.23-.739a6.817 6.817 0 005.296-6.645 5.067 5.067 0 00-5.067-5.067h-4.558"></path>
      </g>
      <defs>
        <clipPath id="clip0_3652_34547">
          <path fill="#fff" d="M0 0H42V42H0z" transform="translate(.5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default CoffeeCupIcon;
